
export enum InputFormatType {
      None =            -1,
      Numeric =         1,
      Alphanumeric =    2,
      Email =           3,
      Phone =           4,
      Zip =             5,
      Url =             8,
      Currency =        9,
      Pattern =         10,
      SocialSecurity =  12,
      Percentage =      19,
}
